import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { MdError } from 'react-icons/md';

import {
  Container,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

import { useDispatch, useSelector } from 'react-redux';
import { comunicadoTelaClose, getComunicadoCodigoTelaRequest } from '~/store/modules/comunicado/actions';

const ModalComunicado = ({codigoTela}) => {
  const dispath = useDispatch();

  const {comunicado} = useSelector(state => state);

  useEffect(() => {
    if(codigoTela)
      dispath(getComunicadoCodigoTelaRequest(codigoTela));
  }, [codigoTela]);

  const handleOk = () => {
    dispath(comunicadoTelaClose());
  };

  const handleCancel = () => {
    dispath(comunicadoTelaClose());
  };
  
  return (
    <Container>
      <Modal
        visible={comunicado.modalIsVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={false}
        cancelText="Conferir depois"
        centered
        footer={null}
        width="480px"
      >
          <ModalContainer>
            <ModalHeader>
              <div className="iconModal">
                <span>
                  <MdError size={30} />
                </span>
              </div>
              <h2>
                {comunicado.comunicado.tituloMensagem}
              </h2>
            </ModalHeader>
        
            <div className="ModalBody">        
              <div> 
                <p>{comunicado.comunicado.corpoMensagem}</p>
              </div>
            </div>
          </ModalContainer>

        <ModalFooter>
          <ButtonModal type="button" onClick={handleOk}>
            Fechar
          </ButtonModal>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

ModalComunicado.propTypes = {
  codigoTela: PropTypes.string.isRequired,
};

export default ModalComunicado;
